import React, { useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  BarElement,
  CategoryScale,
  ChartData,
  ChartOptions,
  Tooltip,
  Chart as ChartJS,
  ArcElement,
} from 'chart.js';

type DoughnutChartWithoutDetailAndLegendProps = {
  metric1: number;
  metric2: number;
};
/* eslint-disable*/
const valueAboveBarsPlugin = {
  id: 'valueAboveBars',
  afterDatasetsDraw: (chart: any) => {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset: any, i: any) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((bar: any, index: any) => {
        const value = dataset.data[index];
        ctx.fillStyle = '#223466';
        ctx.font = 'bold 14px';
        ctx.textAlign = 'center';
        const position = bar.tooltipPosition();
        ctx.fillText(value + '%', position.x, position.y - 10);
      });
    });
  },
};

const DoughnutChartWithoutDetailAndLegend: React.FC<
  DoughnutChartWithoutDetailAndLegendProps
> = ({ metric1, metric2 }) => {
  const chartRef = useRef<ChartJS<'doughnut'> | null>(null);
  ChartJS.register(CategoryScale, ArcElement, BarElement, Tooltip);
  ChartJS.unregister(valueAboveBarsPlugin);
  const data: ChartData<'doughnut'> = {
    labels: ['Dias consumidos', 'Dias restantes'],
    datasets: [
      {
        data: [metric1, metric2],
        backgroundColor: ['#4780bf', '#faae30'],
        hoverBackgroundColor: ['#4780bf', '#faae30'],
        borderWidth: 0, // Quitar borde entre segmentos
      },
    ],
  };

  const options: ChartOptions<'doughnut'> = {
    plugins: {
      legend: {
        display: false, // Ocultar leyenda
      },
      tooltip: {
        enabled: true, // Desactivar tooltips si no son necesarios
      },
    },
    cutout: '70%', // Hacer la dona más fina
  };

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []);

  return <Doughnut data={data} options={options} />;
};

export default DoughnutChartWithoutDetailAndLegend;
